import { setI18nLocale, setLanguageLocalStorage, setPaasLanguageLocalStorage } from '@/i18n'
import { LanguageContent } from '@/lib/util/lang.js'
import { requestApi } from "@/lib/request"

class Header {
    static switchLanguage(str, isReload) {
        setI18nLocale(str)
        setLanguageLocalStorage(str)
        setPaasLanguageLocalStorage(str)
        const lang = LanguageContent.getApiSuffix()
		return requestApi('/common/noauth/lang/switch', 'get', {}, {lang}).then(res => {
            if(res.success && isReload){
                window.location.reload()
            }
        })
    }
}

export {
    Header
}


// WEBPACK FOOTER //
// ./src/models/header.js